import angular from 'angular';
import { NsjRoutingType } from '../../core/nsj-core';
import { IConcessionaria, IConcessionariaGet } from './models/concessionaria.model';
import { LoadParams } from '../../shared/models/loadparams.model';

export class ConcessionariasVtsService {

    static $inject = ['$http', '$rootScope', '$q', 'nsjRouting'];

    public entities: IConcessionaria[] = [];
    public loaded = false;
    public constructors: any = {};
    public after: any = {};
    public filters: any = {};
    public loadParams = new LoadParams();
    public loading_deferred: angular.IDeferred<unknown>;
    public filter: any = '';

    constructor(
        public $http: angular.IHttpService,
        public $rootScope: angular.IScope,
        public $q: angular.IQService,
        public nsjRouting: NsjRoutingType,
    ) { }

    reload() {
        if (this.loading_deferred) {
            this.loading_deferred.resolve();
        }

        this.loadParams.finished = false;
        this.loadParams.to_load = 3;
        this.after = {};
        this.loaded = false;
        this.entities.length = 0;
        this.loadParams.busy = false;

        return this.load();
    }

    search(filter: any) {
        if (typeof filter !== 'undefined') {
            this.filter = filter.search;
            Object.keys(this.filters).forEach((k) => { delete this.filters[k]; });
            for (let fil in filter.filters) {
                if (fil.indexOf('.') > -1) {
                    let filterSplit = fil.split('.');
                    this.filters[filterSplit[0]] = {};
                    this.filters[filterSplit[0]][filterSplit[1]] = filter.filters[fil];
                } else {
                    this.filters[fil] = filter.filters[fil];
                }
            }
        }

        return this.reload();
    }

    _load(constructors: any, offset: any, filter: any) {
        this.loading_deferred = this.$q.defer();

        return this.$q<IConcessionaria[]>((resolve, reject) => {
            this.$http<IConcessionaria[]>({
                method: 'GET',
                url: this.nsjRouting.generate('persona_concessionariasvts_index',
                    angular.extend({}, constructors, { 'offset': offset, 'filter': filter }, this.filters),
                    true
                ),
                timeout: this.loading_deferred.promise
            })
            .then((response) => resolve(response.data))
            .catch((response) => reject(response));
        });

    }

    load() {
        if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
            this.loadParams.busy = true;

            this._load(this.constructors, this.after, this.filter)
                .then((data) => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.entities.push(data[i]);
                        }
                    }
                    this.loadParams.finished = true;
                    this.$rootScope.$broadcast('persona_concessionariasvts_list_finished', this.entities);
                    this.loaded = true;

                    this.loadParams.to_load--;
                })
                .catch((error) => {
                    if (error.xhrStatus !== 'abort') {
                        this.loadParams.finished = true;
                    }
                })
                .finally(() => {
                    if (this.loaded || this.loadParams.finished) {
                        this.loadParams.busy = false;
                    }
                });
        }

        return this.entities;
    }

    loadMore() {
        this.loadParams.to_load = 3;
        this.load();
    }

    get(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<IConcessionariaGet>((resolve, reject) => {
            this.$http.get<IConcessionariaGet>(
                this.nsjRouting.generate('persona_concessionariasvts_get', {
                    id
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('persona_concessionariasvts_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => reject(response));
        });
    }
}

angular.module('main').service('ConcessionariasVtsService', ConcessionariasVtsService);
